













import { Prop, Vue } from "vue-property-decorator";
import Component from "vue-class-component";

import { capitalizeFilter } from "@/filters/capitalize.filter";

import { FalconDocumentsType } from "@/enums/falcon/documents/falcon-documents-type.enum";
import { I18nMessageKey } from "@/enums/i18n-message-key.enum";

/**
 * @author Damian Kajzer <damian.kajzer@sowlgroup.com>
 * Falcon documents filters final documents form field component
 */
@Component({
  filters: {
    ...capitalizeFilter
  }
})
export default class DocumentsFiltersTypeFormField extends Vue {
  @Prop() private setDocumentsType!: (
    documentsType: FalconDocumentsType
  ) => void;
  private documentsType: FalconDocumentsType =
    FalconDocumentsType.InvoicesAndAssignations;

  documentsTypeEnum = FalconDocumentsType;
  i18nMessageKeyEnum = I18nMessageKey;

  mounted(): void {
    this.documentsTypeUpdated();
  }

  private documentsTypeUpdated(): void {
    this.setDocumentsType(this.documentsType);
  }
}
